module.exports = __webpack_public_path__ + "img/work-slide-01-small.58ce5778.jpg";